import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const CarHearts = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.391 19.618h2.18m-2.18 0v1.667s-.089.715 1.046.715c1.134 0 1.134-.715 1.134-.715v-1.668m-2.18 0H7.547m10.526-6.313c.455 0 .847.097 1.183.258 1.136.545 1.632 1.821 1.744 2.541v2.86c0 .571-.457.674-.685.654H18.57m-.498-6.313H5.99m.422-1.37.699-2.263c.166-.378.81-1.132 2.055-1.132h5.287c1.432 0 2 .512 2.25 1.132.157.392.523 1.362.86 2.263l.51 1.37m-12.083 0 .422-1.37m-.422 1.37c-.37.052-.879.188-1.37.437m12.943-1.807h.821c.29.013.872.198.872.834v.794M6.412 11.935H5.367c-.312 0-.748.405-.748.834v.973m0 0C3.787 14.163 3 14.906 3 16.103v2.86c.042.218.287.654.934.654h1.433m0 0v1.668S5.277 22 6.412 22s1.135-.715 1.135-.715v-1.668m-2.18 0h2.18m6.29-2.566H10.1M9.323 3.696a.77.77 0 0 0-.432.135.8.8 0 0 0-.286.359.8.8 0 0 0-.286-.359.77.77 0 0 0-.432-.135.84.84 0 0 0-.556.283.88.88 0 0 0-.22.595c0 .96 1.295 1.743 1.494 1.743S10.1 5.535 10.1 4.574a.88.88 0 0 0-.22-.596.84.84 0 0 0-.557-.282M15.103 3c-.217 0-.43.067-.611.191a1.1 1.1 0 0 0-.405.505 1.1 1.1 0 0 0-.405-.505A1.1 1.1 0 0 0 13.069 3a1.2 1.2 0 0 0-.788.398 1.24 1.24 0 0 0-.312.839c0 1.354 1.836 2.456 2.118 2.456s2.117-1.102 2.117-2.456a1.24 1.24 0 0 0-.312-.839A1.2 1.2 0 0 0 15.105 3m3.592 13.103c0 .527-.446.953-.996.953s-.997-.426-.997-.953.447-.953.997-.953.996.427.996.953m-11.584 0c0 .527-.446.953-.997.953s-.996-.426-.996-.953.446-.953.996-.953.997.427.997.953"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(CarHearts) as SvgIcon;
export { ForwardRef as ReactComponent };
